import { render, staticRenderFns } from "./importantClient.vue?vue&type=template&id=625ba06e&"
import script from "./importantClient.vue?vue&type=script&lang=js&"
export * from "./importantClient.vue?vue&type=script&lang=js&"
import style0 from "./importantClient.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports